
import { defineComponent, ref, Ref } from 'vue';
import Verification1 from '@/components/Entrance/FindPassword/Verification1.vue';
import Verification2 from '@/components/Entrance/FindPassword/Verification2.vue';
import ChangePassword from '@/components/Entrance/FindPassword/ChangePassword.vue';
import Complete from '@/components/Entrance/FindPassword/Complete.vue';

export default defineComponent({
  components: {
    Verification1,
    Verification2,
    ChangePassword,
    Complete,
  },
  setup() {
    //与子组件共享数据
    const phoneNumber = ref('123');
    //状态标志
    let flag1 = ref(true);
    let flag2 = ref(false);
    let flag3 = ref(false);

    let verificating1 = ref(true);
    let verificating2 = ref(false);
    let changePassword = ref(false);
    let complete = ref(false);

    let next1 = () => {
      verificating1.value = false;
      verificating2.value = true;
    };
    let next2 = () => {
      verificating2.value = false;
      changePassword.value = true;
      flag2.value = true;
      console.log('nex2');
    };
    let confirmChange = () => {
      changePassword.value = false;
      complete.value = true;
      flag3.value = true;
    };

    return {
      phoneNumber,
      //顶部栏修改密码的进程标志值
      flag1,
      flag2,
      flag3,
      //修改密码各阶段的标志值
      verificating1,
      verificating2,
      changePassword,
      complete,
      //传给子组件的方法，用于跳转到下一个修改密码的阶段
      next1,
      next2,
      confirmChange,
    };
  },
});
